import { render } from "./hand-12.vue?vue&type=template&id=11b96d9a&scoped=true"
import script from "./hand-12.vue?vue&type=script&lang=js"
export * from "./hand-12.vue?vue&type=script&lang=js"

import "./hand-12.vue?vue&type=style&index=0&id=11b96d9a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b96d9a"]])

export default __exports__